























































import { defineComponent, toRefs } from '@vue/composition-api';
import AppButton from '@berlin-front/common/components/elements/AppButton';
import AppCard from '@berlin-front/common/components/elements/AppCard';
import AppContainer from '@berlin-front/common/components/elements/AppContainer';
import AppLink from '@berlin-front/common/components/elements/AppLink';
import AppMessageList from '@berlin-front/common/components/elements/AppMessageList';
import AppRow from '@berlin-front/common/components/elements/AppRow';
import AppText from '@berlin-front/common/components/elements/AppText';
import AppSupplement from '@berlin-front/common/components/elements/AppSupplement';
import ModalHeader from '@berlin-front/common/components/clusters/ModalHeader';

import { useContext } from '@berlin-front/common/composables/context';

import { ModalHeaderContext } from '@services/ModalHeaderContext';
import { HEADER_TYPE } from '@berlin-front/common/components/clusters/ModalHeader/composable';
import { TEXT_SIZE, TEXT_WEIGHT } from '@berlin-front/common/components/elements/AppText/composable';

import exclamationCircleIcon from '@berlin-front/common/assets/exclamation-circle-icon.svg';
import { OfficialIdentificationFailContext } from './composable';

export default defineComponent({
  name: 'OfficialIdentificationFailView',
  components: {
    AppButton,
    AppCard,
    AppContainer,
    AppLink,
    AppMessageList,
    AppRow,
    AppSupplement,
    AppText,
    ModalHeader,
    HeaderContextConsumer: ModalHeaderContext.consumer,
  },

  setup() {
    const { useOfficialIdentificationFail } = useContext(OfficialIdentificationFailContext);
    const { cancelClick, openAppClick } = toRefs(useOfficialIdentificationFail());

    const messages = [
      '身分証明証は atone のスマホアプリからご提出ください。',
      '本人確認の審査に最短でも5分かかります。予めご容赦ください。',
    ];

    return {
      // 状態

      // 表示項目
      imgSrc: exclamationCircleIcon,
      messages,
      OFFICIAL_IDENTIFICATION_DETAIL_URL: process.env.VUE_APP_ATONE_OFFICIAL_IDENTIFICATION_DETAIL_URL,

      // 関数
      cancelClick,
      openAppClick,

      // 定数
      HEADER_TYPE,
      TEXT_SIZE,
      TEXT_WEIGHT,
    };
  },
});
